const config = {
  builder_id: '5702b8fdf410954eb27cf605',
  auth_domain: 'swwold.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  social_links: {
    facebook: '/images/icon-social-facebook.svg',
    instagram: '/images/icon-social-instagram.svg',
    youtube: '/images/icon-social-youtube.svg',
    pinterest: '/images/icon-social-pinterest.svg',
    twitter: '/images/icon-social-twitter.svg',
    houzz: '/images/icon-social-houzz.svg',
    linkedin: '/images/icon-social-linkedin.svg',
    googleplus: '/images/icon-social-google-plus.svg',
    fallback: '/images/icon-social-baths.svg',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2ptMHY2bzlrMGZqdTNxcG4yemhwcjAwbyJ9.ms7Wax5nEg806wbZkrseyA',
  },
  filters: {
    all: {},
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js